






















import { defineComponent } from '@vue/composition-api';
import { SidebarPlacement } from '@getaccept/dsr-shared';
import { storeToRefs } from 'pinia';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { useParticipantsStore } from '../../store/participants.store';
import { useChatPublishedStore } from '../store/chat-published.store';
import ChatWrapper from './ChatWrapper.vue';

export default defineComponent({
  name: 'Chat',
  components: {
    ChatWrapper,
  },
  props: {
    loaded: {
      type: Boolean,
    },
    recipientId: {
      required: true,
      type: String,
    },
  },
  setup() {
    const participantsStore = useParticipantsStore();
    const chatPublishedStore = useChatPublishedStore();
    const { recipients } = storeToRefs(participantsStore);
    const { lastGeneralChatMessage } = storeToRefs(chatPublishedStore);

    return {
      SidebarPlacement,
      recipients,
      t,
      lastGeneralChatMessage,
    };
  },
});
